{
  "welcome": {
    "title": "Karibu, {{name}}",
    "title_noName": "Karibu Rhemn",
    "body": "Kila kinachong'aa kitakuonyesha kinachofanya. Gundua kwa mpangilio wowote, wakati wowote upendao.",
    "start": "Anza kugundua",
    "later": "Si sasa"
  },
  "card": {
    "tryIt": "Jaribu",
    "takeALook": "Tazama",
    "pro": "Sehemu ya Rhemn Pro",
    "close_aria": "Funga"
  },
  "pill": {
    "progress": "{{count}} kati ya {{total}} zimegunduliwa",
    "progress_short": "{{count}}/{{total}}",
    "done": "Maliza",
    "done_aria": "Maliza kugundua",
    "complete": "Zote zimegunduliwa"
  },
  "sr": {
    "started": "Hali ya kugundua imewashwa. Vitufe vinaonyesha kazi yao kabla ya kutenda.",
    "hint": "Hali ya kugundua. Huonyesha kwanza kazi ya kitufe hiki.",
    "ended": "Hali ya kugundua imezimwa."
  },
  "settings": {
    "row": "Jinsi Rhemn inavyofanya kazi",
    "row_sub": "Mtazamo mfupi wa kila sehemu",
    "row_aria": "Jinsi Rhemn inavyofanya kazi: gundua programu tena",
    "helpCaption": "Msaada"
  },
  "steps": {
    "intention": {
      "title": "Nia ya leo",
      "body": "Andika jambo moja muhimu zaidi leo, na uliwekee alama likikamilika."
    },
    "now": {
      "title": "Siku yako, kwa swala",
      "body": "Rhemn hugawa siku yako kila swala. Hapa unaona muda uliobaki kabla ya swala inayofuata, na ulichopanga kwa kipindi hicho."
    },
    "verse": {
      "title": "Mwanga wa aya",
      "body": "Uliza swali kuhusu aya ya leo, soma tafsiri fupi, na upate aya zenye mada ileile."
    },
    "qibla": {
      "title": "Kibla",
      "body_chrome": "Mwelekeo wa Al-Kaaba kutoka ulipo, kwa nyuzi kutoka kaskazini.",
      "body_ios": "Huelekeza kwenye Al-Kaaba kutoka ulipo. Washa dira hai nayo itakufuata unapogeuka."
    },
    "prayer": {
      "title": "Nyakati za swala",
      "body_chrome": "Nyakati tano za swala za leo kwa mahali ulipo. Chagua mbinu ya kukokotoa inayofuatwa na msikiti wako.",
      "body_ios": "Swala yako inayofuata kwa mtazamo mmoja. Ifungue uone nyakati zote tano na kikumbusho kwa kila moja."
    },
    "tasks": {
      "title": "Kazi",
      "body": "Weka kazi zako katika orodha, na upe kila moja nafasi kati ya swala."
    },
    "notes": {
      "title": "Madokezo",
      "body_chrome": "Andika, au zungumza tu. Rhemn huandika madokezo yako ya sauti na mikutano, kisha huyafupisha.",
      "body_ios": "Andika, au zungumza tu. Rhemn hubadilisha unachosema kuwa madokezo safi yaliyofupishwa."
    },
    "profile": {
      "title_chrome": "Wasifu wako",
      "body_chrome": "Mipangilio ya akaunti na faragha yako. Rudi hapa ili kugundua Rhemn tena.",
      "title_ios": "Zaidi",
      "body_ios": "Aya zilizohifadhiwa, Kibla, na mipangilio ya akaunti yako. Unaweza kugundua Rhemn tena kutoka hapa."
    }
  }
}
